export const kpisJSON = [
  {
    "model": "easySCOPE (generisch)",
    "kpis": [
      {
        "name": "ratiorejectdetectionvsproductstotal"
      },
      {
        "name": "rejectdetectiontotal"
      },
      {
        "name": "productstotal"
      },
      {
        "name": "detectortests24h"
      },
      {
        "name": "runtimedrivecomponents"
      }
    ]
  },
  {
    "model": "easySCOPE 600",
    "kpis": [
      {
        "name": "ratiorejectdetectionvsproductstotal"
      },
      {
        "name": "rejectdetectiontotal"
      },
      {
        "name": "productstotal"
      },
      {
        "name": "detectortests24h"
      },
      {
        "name": "runtimedrivecomponents"
      }
    ]
  },
  {
    "model": "easySCOPE 400",
    "kpis": [
      {
        "name": "ratiorejectdetectionvsproductstotal"
      },
      {
        "name": "rejectdetectiontotal"
      },
      {
        "name": "productstotal"
      },
      {
        "name": "detectortests24h"
      },
      {
        "name": "runtimedrivecomponents"
      }
    ]
  },
  {
    "model": "easySCOPE MT",
    "kpis": [
      {
        "name": "ratiorejectdetectionvsproductstotal"
      },
      {
        "name": "rejectdetectiontotal"
      },
      {
        "name": "productstotal"
      },
      {
        "name": "detectortests24h"
      },
      {
        "name": "runtimedrivecomponents"
      }
    ]
  },
  {
    "model": "easySCOPE ST",
    "kpis": [
      {
        "name": "ratiorejectdetectionvsproductstotal"
      },
      {
        "name": "rejectdetectiontotal"
      },
      {
        "name": "productstotal"
      },
      {
        "name": "detectortests24h"
      },
      {
        "name": "runtimedrivecomponents"
      }
    ]
  },
  {
    "model": "HighSpeedTEXREJECT",
    "kpis": [
      {
        "name": "rejectdetectiontotal"
      },
      {
        "name": "switchingcycles"
      }
    ]
  },
  {
    "model": "MEATLINE 07",
    "kpis": [
      {
        "name": "rejectdetectiontotal"
      },
      {
        "name": "detectortests24h"
      }
    ]
  },
  {
    "model": "MEATLINE 07 LE",
    "kpis": [
      {
        "name": "rejectdetectiontotal"
      },
      {
        "name": "detectortests24h"
      }
    ]
  },
  {
    "model": "MEATLINE 07 O",
    "kpis": [
      {
        "name": "rejectdetectiontotal"
      },
      {
        "name": "detectortests24h"
      },
      {
        "name": "switchingcycles"
      }
    ]
  },
  {
    "model": "METRON (generisch)",
    "kpis": [
      {
        "name": "rejectdetectiontotal"
      },
      {
        "name": "detectortests24h"
      }
    ]
  },
  {
    "model": "METRON (generisch) mit Produkttrigger",
    "kpis": [
      {
        "name": "productstotal"
      },
      {
        "name": "detectortests24h"
      }
    ]
  },
  {
    "model": "METRON 03 D",
    "kpis": [
      {
        "name": "rejectdetectiontotal"
      },
      {
        "name": "detectortests24h"
      }
    ]
  },
  {
    "model": "METRON 03 S",
    "kpis": [
      {
        "name": "rejectdetectiontotal"
      },
      {
        "name": "detectortests24h"
      }
    ]
  },
  {
    "model": "METRON 03 SL",
    "kpis": [
      {
        "name": "rejectdetectiontotal"
      },
      {
        "name": "detectortests24h"
      }
    ]
  },
  {
    "model": "METRON 04 PR",
    "kpis": [
      {
        "name": "rejectdetectiontotal"
      },
      {
        "name": "detectortests24h"
      }
    ]
  },
  {
    "model": "METRON 05 C",
    "kpis": [
      {
        "name": "rejectdetectiontotal"
      },
      {
        "name": "detectortests24h"
      }
    ]
  },
  {
    "model": "METRON 05 CI",
    "kpis": [
      {
        "name": "rejectdetectiontotal"
      },
      {
        "name": "detectortests24h"
      }
    ]
  },
  {
    "model": "METRON 05 CO",
    "kpis": [
      {
        "name": "rejectdetectiontotal"
      },
      {
        "name": "detectortests24h"
      }
    ]
  },
  {
    "model": "METRON 05 CR",
    "kpis": [
      {
        "name": "rejectdetectiontotal"
      },
      {
        "name": "detectortests24h"
      }
    ]
  },
  {
    "model": "METRON 05 D",
    "kpis": [
      {
        "name": "rejectdetectiontotal"
      },
      {
        "name": "detectortests24h"
      }
    ]
  },
  {
    "model": "METRON 05 FL",
    "kpis": [
      {
        "name": "rejectdetectiontotal"
      },
      {
        "name": "detectortests24h"
      }
    ]
  },
  {
    "model": "METRON 05 PR",
    "kpis": [
      {
        "name": "rejectdetectiontotal"
      },
      {
        "name": "detectortests24h"
      }
    ]
  },
  {
    "model": "METRON 05 PW",
    "kpis": [
      {
        "name": "rejectdetectiontotal"
      },
      {
        "name": "detectortests24h"
      }
    ]
  },
  {
    "model": "METRON 05 PWT",
    "kpis": [
      {
        "name": "rejectdetectiontotal"
      },
      {
        "name": "detectortests24h"
      }
    ]
  },
  {
    "model": "METRON 05 S",
    "kpis": [
      {
        "name": "rejectdetectiontotal"
      },
      {
        "name": "detectortests24h"
      }
    ]
  },
  {
    "model": "METRON 05 SL",
    "kpis": [
      {
        "name": "rejectdetectiontotal"
      },
      {
        "name": "detectortests24h"
      }
    ]
  },
  {
    "model": "METRON 05 SN",
    "kpis": [
      {
        "name": "rejectdetectiontotal"
      },
      {
        "name": "detectortests24h"
      }
    ]
  },
  {
    "model": "METRON 05 U",
    "kpis": [
      {
        "name": "rejectdetectiontotal"
      },
      {
        "name": "detectortests24h"
      }
    ]
  },
  {
    "model": "METRON 05 VT",
    "kpis": [
      {
        "name": "rejectdetectiontotal"
      },
      {
        "name": "detectortests24h"
      }
    ]
  },
  {
    "model": "METRON 07 CI",
    "kpis": [
      {
        "name": "rejectdetectiontotal"
      },
      {
        "name": "detectortests24h"
      }
    ]
  },
  {
    "model": "METRON 07 CRI",
    "kpis": [
      {
        "name": "rejectdetectiontotal"
      },
      {
        "name": "detectortests24h"
      }
    ]
  },
  {
    "model": "METRON 07 FL",
    "kpis": [
      {
        "name": "rejectdetectiontotal"
      },
      {
        "name": "detectortests24h"
      }
    ]
  },
  {
    "model": "METRON 07 PR",
    "kpis": [
      {
        "name": "rejectdetectiontotal"
      },
      {
        "name": "detectortests24h"
      }
    ]
  },
  {
    "model": "METRON 07 PW",
    "kpis": [
      {
        "name": "rejectdetectiontotal"
      },
      {
        "name": "detectortests24h"
      }
    ]
  },
  {
    "model": "METRON 07 S",
    "kpis": [
      {
        "name": "rejectdetectiontotal"
      },
      {
        "name": "detectortests24h"
      }
    ]
  },
  {
    "model": "METRON 07 SN",
    "kpis": [
      {
        "name": "rejectdetectiontotal"
      },
      {
        "name": "detectortests24h"
      }
    ]
  },
  {
    "model": "METRON 05 V",
    "kpis": [
      {
        "name": "rejectdetectiontotal"
      },
      {
        "name": "detectortests24h"
      }
    ]
  },
  {
    "model": "PHARMATRON 07 HQ",
    "kpis": [
      {
        "name": "rejectdetectiontotal"
      },
      {
        "name": "detectortests24h"
      },
      {
        "name": "switchingcycles"
      }
    ]
  },
  {
    "model": "PIPELINE 07",
    "kpis": [
      {
        "name": "rejectdetectiontotal"
      },
      {
        "name": "detectortests24h"
      }
    ]
  },
  {
    "model": "PIPELINE 07 O",
    "kpis": [
      {
        "name": "rejectdetectiontotal"
      },
      {
        "name": "detectortests24h"
      },
      {
        "name": "switchingcycles"
      }
    ]
  },
  {
    "model": "P-TRON (generisch)",
    "kpis": [
      {
        "name": "rejectdetectiontotal"
      },
      {
        "name": "detectortests24h"
      },
      {
        "name": "switchingcycles"
      }
    ]
  },
  {
    "model": "P-TRON 03 A",
    "kpis": [
      {
        "name": "rejectdetectiontotal"
      },
      {
        "name": "detectortests24h"
      },
      {
        "name": "switchingcycles"
      }
    ]
  },
  {
    "model": "P-TRON 03 FM",
    "kpis": [
      {
        "name": "rejectdetectiontotal"
      },
      {
        "name": "detectortests24h"
      },
      {
        "name": "switchingcycles"
      }
    ]
  },
  {
    "model": "P-TRON 05 A",
    "kpis": [
      {
        "name": "rejectdetectiontotal"
      },
      {
        "name": "detectortests24h"
      },
      {
        "name": "switchingcycles"
      }
    ]
  },
  {
    "model": "P-TRON 05 FM",
    "kpis": [
      {
        "name": "rejectdetectiontotal"
      },
      {
        "name": "detectortests24h"
      },
      {
        "name": "switchingcycles"
      }
    ]
  },
  {
    "model": "P-TRON 05 GM",
    "kpis": [
      {
        "name": "rejectdetectiontotal"
      },
      {
        "name": "detectortests24h"
      },
      {
        "name": "switchingcycles"
      }
    ]
  },
  {
    "model": "P-TRON 07 GM",
    "kpis": [
      {
        "name": "rejectdetectiontotal"
      },
      {
        "name": "detectortests24h"
      },
      {
        "name": "switchingcycles"
      }
    ]
  },
  {
    "model": "PLASTRON 05 K",
    "kpis": [
      {
        "name": "rejectdetectiontotal"
      },
      {
        "name": "detectortests24h"
      },
      {
        "name": "switchingcycles"
      }
    ]
  },
  {
    "model": "QUICKTRON (generisch)",
    "kpis": [
      {
        "name": "rejectdetectiontotal"
      },
      {
        "name": "detectortests24h"
      },
      {
        "name": "switchingcycles"
      }
    ]
  },
  {
    "model": "QUICKTRON 03 A",
    "kpis": [
      {
        "name": "rejectdetectiontotal"
      },
      {
        "name": "detectortests24h"
      },
      {
        "name": "switchingcycles"
      }
    ]
  },
  {
    "model": "QUICKTRON 03 E",
    "kpis": [
      {
        "name": "rejectdetectiontotal"
      },
      {
        "name": "detectortests24h"
      },
      {
        "name": "switchingcycles"
      }
    ]
  },
  {
    "model": "QUICKTRON 03 R",
    "kpis": [
      {
        "name": "rejectdetectiontotal"
      },
      {
        "name": "detectortests24h"
      },
      {
        "name": "switchingcycles"
      }
    ]
  },
  {
    "model": "QUICKTRON 05 A",
    "kpis": [
      {
        "name": "rejectdetectiontotal"
      },
      {
        "name": "detectortests24h"
      },
      {
        "name": "switchingcycles"
      }
    ]
  },
  {
    "model": "QUICKTRON 05 B",
    "kpis": [
      {
        "name": "rejectdetectiontotal"
      },
      {
        "name": "detectortests24h"
      },
      {
        "name": "switchingcycles"
      }
    ]
  },
  {
    "model": "QUICKTRON 05 CB",
    "kpis": [
      {
        "name": "rejectdetectiontotal"
      },
      {
        "name": "detectortests24h"
      },
      {
        "name": "switchingcycles"
      }
    ]
  },
  {
    "model": "QUICKTRON 05 E",
    "kpis": [
      {
        "name": "rejectdetectiontotal"
      },
      {
        "name": "detectortests24h"
      },
      {
        "name": "switchingcycles"
      }
    ]
  },
  {
    "model": "QUICKTRON 05 RH",
    "kpis": [
      {
        "name": "rejectdetectiontotal"
      },
      {
        "name": "detectortests24h"
      },
      {
        "name": "switchingcycles"
      }
    ]
  },
  {
    "model": "QUICKTRON 07 RH",
    "kpis": [
      {
        "name": "rejectdetectiontotal"
      },
      {
        "name": "detectortests24h"
      },
      {
        "name": "switchingcycles"
      }
    ]
  },
  {
    "model": "TRANSTRON (generisch)",
    "kpis": [
      {
        "name": "rejectdetectiontotal"
      },
      {
        "name": "detectortests24h"
      },
      {
        "name": "runtimedrivecomponents"
      }
    ]
  },
  {
    "model": "TRANSTRON (generisch) mit Lichtschranke",
    "kpis": [
      {
        "name": "ratiorejectdetectionvsproductstotal"
      },
      {
        "name": "rejectdetectiontotal"
      },
      {
        "name": "productstotal"
      },
      {
        "name": "detectortests24h"
      },
      {
        "name": "runtimedrivecomponents"
      }
    ]
  },
  {
    "model": "TRANSTRON C",
    "kpis": [
      {
        "name": "rejectdetectiontotal"
      },
      {
        "name": "detectortests24h"
      },
      {
        "name": "runtimedrivecomponents"
      }
    ]
  },
  {
    "model": "TRANSTRON C mit Produkttrigger",
    "kpis": [
      {
        "name": "ratiorejectdetectionvsproductstotal"
      },
      {
        "name": "rejectdetectiontotal"
      },
      {
        "name": "productstotal"
      },
      {
        "name": "detectortests24h"
      },
      {
        "name": "runtimedrivecomponents"
      }
    ]
  },
  {
    "model": "TRANSTRON GF",
    "kpis": [
      {
        "name": "rejectdetectiontotal"
      },
      {
        "name": "detectortests24h"
      },
      {
        "name": "runtimedrivecomponents"
      }
    ]
  },
  {
    "model": "TRANSTRON GF mit Produkttrigger",
    "kpis": [
      {
        "name": "ratiorejectdetectionvsproductstotal"
      },
      {
        "name": "rejectdetectiontotal"
      },
      {
        "name": "productstotal"
      },
      {
        "name": "detectortests24h"
      },
      {
        "name": "runtimedrivecomponents"
      }
    ]
  },
  {
    "model": "TRANSTRON HL",
    "kpis": [
      {
        "name": "rejectdetectiontotal"
      },
      {
        "name": "detectortests24h"
      },
      {
        "name": "runtimedrivecomponents"
      }
    ]
  },
  {
    "model": "TRANSTRON HL mit Produkttrigger",
    "kpis": [
      {
        "name": "ratiorejectdetectionvsproductstotal"
      },
      {
        "name": "rejectdetectiontotal"
      },
      {
        "name": "productstotal"
      },
      {
        "name": "detectortests24h"
      },
      {
        "name": "runtimedrivecomponents"
      }
    ]
  },
  {
    "model": "TRANSTRON K",
    "kpis": [
      {
        "name": "rejectdetectiontotal"
      },
      {
        "name": "detectortests24h"
      },
      {
        "name": "runtimedrivecomponents"
      }
    ]
  },
  {
    "model": "TRANSTRON K mit Produkttrigger",
    "kpis": [
      {
        "name": "ratiorejectdetectionvsproductstotal"
      },
      {
        "name": "rejectdetectiontotal"
      },
      {
        "name": "productstotal"
      },
      {
        "name": "detectortests24h"
      },
      {
        "name": "runtimedrivecomponents"
      }
    ]
  },
  {
    "model": "TRANSTRON L",
    "kpis": [
      {
        "name": "rejectdetectiontotal"
      },
      {
        "name": "detectortests24h"
      },
      {
        "name": "runtimedrivecomponents"
      }
    ]
  },
  {
    "model": "TRANSTRON L mit Produkttrigger",
    "kpis": [
      {
        "name": "ratiorejectdetectionvsproductstotal"
      },
      {
        "name": "rejectdetectiontotal"
      },
      {
        "name": "productstotal"
      },
      {
        "name": "detectortests24h"
      },
      {
        "name": "runtimedrivecomponents"
      }
    ]
  },
  {
    "model": "TRANSTRON M",
    "kpis": [
      {
        "name": "rejectdetectiontotal"
      },
      {
        "name": "detectortests24h"
      },
      {
        "name": "runtimedrivecomponents"
      }
    ]
  },
  {
    "model": "TRANSTRON M mit Produkttrigger",
    "kpis": [
      {
        "name": "ratiorejectdetectionvsproductstotal"
      },
      {
        "name": "rejectdetectiontotal"
      },
      {
        "name": "productstotal"
      },
      {
        "name": "detectortests24h"
      },
      {
        "name": "runtimedrivecomponents"
      }
    ]
  },
  {
    "model": "TRANSTRON S",
    "kpis": [
      {
        "name": "rejectdetectiontotal"
      },
      {
        "name": "detectortests24h"
      },
      {
        "name": "runtimedrivecomponents"
      }
    ]
  },
  {
    "model": "TRANSTRON S mit Produkttrigger",
    "kpis": [
      {
        "name": "ratiorejectdetectionvsproductstotal"
      },
      {
        "name": "rejectdetectiontotal"
      },
      {
        "name": "productstotal"
      },
      {
        "name": "detectortests24h"
      },
      {
        "name": "runtimedrivecomponents"
      }
    ]
  },
  {
    "model": "METRON 05 PWT + HighSpeedTEXREJECT",
    "kpis": [
      {
        "name": "rejectdetectiontotal"
      },
      {
        "name": "detectortests24h"
      },
      {
        "name": "switchingcycles"
      }
    ]
  },
  {
    "model": "Inspektionssystem (generisch)",
    "kpis": [
      {
        "name": "rejectdetectiontotal"
      },
      {
        "name": "detectortests24h"
      }
    ]
  },
  {
    "model": "Inspektionssystem (generisch) mit Produkttrigger",
    "kpis": [
      {
        "name": "ratiorejectdetectionvsproductstotal"
      },
      {
        "name": "rejectdetectiontotal"
      },
      {
        "name": "productstotal"
      },
      {
        "name": "detectortests24h"
      }
    ]
  },
  {
    "model": "Fremdsystem (generisch)",
    "kpis": [
      {
        "name": "rejectdetectiontotal"
      },
      {
        "name": "detectortests24h"
      }
    ]
  },
  {
    "model": "Fremdsystem (generisch) mit Produkttrigger",
    "kpis": [
      {
        "name": "ratiorejectdetectionvsproductstotal"
      },
      {
        "name": "rejectdetectiontotal"
      },
      {
        "name": "productstotal"
      },
      {
        "name": "detectortests24h"
      }
    ]
  }
]